'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRotate90DegreesCcw = function MdRotate90DegreesCcw(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.3 11.1q4.3 4.4 4.3 10.6t-4.3 10.6q-4.3 4.3-10.7 4.3-3.8 0-7.1-1.8l2.5-2.5q2.1 1.1 4.6 1.1 4.9 0 8.3-3.5 3.4-3.3 3.4-8.2t-3.4-8.3q-3.4-3.4-8.3-3.4v5.4l-7-7 7-7.1v5.3q6.4 0 10.7 4.5z m-26.1 10.4l6.1 6.1 6.1-6.1-6.1-6.1z m6.1-10.8l10.7 10.8-10.7 10.8-10.9-10.8z' })
        )
    );
};

exports.default = MdRotate90DegreesCcw;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/rotate-90-degrees-ccw.js
// module id = 1403
// module chunks = 36573943044255 79611799117203 213534597649335